import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const IntroSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    gsap.fromTo(
      el.children,
      { opacity: 0, y: 25 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.15,
        duration: 1.2,
        ease: 'power3.out',
      }
    );
  }, []);

  const handleScrollDown = () => {
    window.scrollTo({
      top: window.innerHeight * 1.1,
      behavior: 'smooth',
    });
  };

  return (
    <section
      ref={sectionRef}
      style={{
        position: 'absolute',
        top: '0vh',
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '0 20px',
        pointerEvents: 'none',
      }}
    >
      <h1
        className="text-display"
        style={{
          marginBottom: '1.25rem',
          maxWidth: '960px',
          lineHeight: 1.05,
        }}
      >
        PLAY. CREATE. EXPLORE.
      </h1>

      <p
        className="text-body"
        style={{
          color: 'var(--text-secondary)',
          fontSize: 'clamp(1.05rem, 1.35vw, 1.3rem)',
          maxWidth: '580px',
          marginBottom: '2.8rem',
          lineHeight: 1.5,
        }}
      >
        Welcome to <strong style={{ color: 'var(--text-primary)' }}>LazPlay</strong>. A continuous cosmic universe of games and software.
      </p>

      <button
        onClick={handleScrollDown}
        className="glass-capsule"
        style={{
          padding: '16px 48px',
          color: 'var(--accent)',
          border: '1px solid var(--accent)',
          letterSpacing: '0.12em',
          fontWeight: 600,
          fontSize: '0.88rem',
          cursor: 'pointer',
          pointerEvents: 'auto',
          background: 'var(--glass)',
          transition: 'all 0.3s ease',
          boxShadow: '0 0 15px var(--accent-dim)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.04)';
          e.currentTarget.style.boxShadow = '0 0 25px var(--accent-glow)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 0 15px var(--accent-dim)';
        }}
      >
        START EXPLORING &rarr;
      </button>

      {/* Subtle Scroll Travel Waypoint Indicator */}
      <div
        style={{
          position: 'absolute',
          bottom: '36px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
          opacity: 0.6,
        }}
      >
        <div
          style={{
            fontSize: '0.62rem',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            color: 'var(--text-muted)',
            fontWeight: 600,
          }}
        >
          SCROLL TO TRAVEL
        </div>
        <div
          style={{
            width: '1.5px',
            height: '24px',
            background: 'linear-gradient(to bottom, var(--accent), transparent)',
            borderRadius: '1px',
          }}
        />
      </div>
    </section>
  );
};

export default IntroSection;
